export default __webpack_public_path__ + "static/media/Spectral-LightItalic.c2d107dd.ttf";